import React from 'react';
import styled from 'styled-components';

import List from 'antd/es/list';

import { Row } from 'components/layout';

import SettingInput from './SettingInput';

const StyledList = styled(List)`
  min-width: 75%;

  & .ant-list-item {
    padding: 16px 0;
  }

  & .ant-list-item-meta {
    margin-right: 16px;
  }

  & .ant-list-item-meta-title {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0;
  }

  & .ant-list-item-meta-description {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
  }
`;

const SettingsList = ({ settingsSchema = [], settingsValues = [], setSettingsValues }) => {

  const expandedInputStyle = {
    minWidth: "200px",
    maxWidth: "100%",
    width: "auto",
    padding: "8px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  return (
    <StyledList
      itemLayout="horizontal"
      dataSource={settingsSchema}
      locale={{
        emptyText: "settings cannot be updated at the moment"
      }}
      renderItem={schema => {
        const { name: settingName, inputType = 'text', title, description, ...rest } = schema;
        const settingValue = settingsValues.find(setting => setting.name === settingName);
        
        return (
          <List.Item>
            <List.Item.Meta
              title={title}
              description={description || settingValue?.description || ''}
            />
            <Row justify="end">
              <SettingInput
                type={inputType}
                value={settingValue?.value !== undefined ? settingValue.value : null}
                onChange={value => {
                  if (settingValue) {
                    settingValue.value = value;
                    settingValue.modified = true;
                  }
                  setSettingsValues([...settingsValues]);
                }}
                style={['text', 'email', 'textarea'].includes(inputType) ? expandedInputStyle : {}}
                {
                  ...(inputType === 'percentage' || inputType === 'number'
                      ? {
                          min: schema.min,
                          max: schema.max,
                        }
                      : {}
                    )
                }
                {...rest}
              />
            </Row>
          </List.Item>
        );
      }}
    />
  );
};

export default SettingsList;
